import L_HTML5 from "../assets/img/skills/html-5.svg";
import L_CSS3 from "../assets/img/skills/css3.svg";
import L_SASS from "../assets/img/skills/sass-1.svg";
import L_BOOTSTRAP from "../assets/img/skills/bootstrap-4.svg";
import L_REACT from "../assets/img/skills/react.svg";
import L_REDUX from "../assets/img/skills/redux.svg";
import L_REACT_ROUTER from "../assets/img/skills/react-router.svg";
import L_MATERIALUI from "../assets/img/skills/material-ui-1.svg";
import L_REACT_BOOTSTRAP from "../assets/img/skills/react-bootstrap.svg";
import L_NODE_JS from "../assets/img/skills/nodejs.svg";
import L_EXPRESS from "../assets/img/skills/express.svg";
import L_MONGODB from "../assets/img/skills/mongodb.svg";
import L_FIREBASE from "../assets/img/skills/firebase-seeklogo.com.svg";
import L_MSSQL from "../assets/img/skills/mssql.svg";
import L_GIT from "../assets/img/skills/git-icon.svg";
import L_HEROKU from "../assets/img/skills/heroku.svg";
import L_GITHUB_PAGES from "../assets/img/skills/github.svg";
import L_JAVASCRIPT from "../assets/img/skills/javascript.svg";
import L_TYPESCRIPT from "../assets/img/skills/typescript.svg";
import L_NETLIFY from "../assets/img/skills/netlify.svg";
import L_PYTHON from "../assets/img/skills/python.svg";
import L_NEXT from "../assets/img/skills/next.svg";
import L_FIGMA from "../assets/img/skills/figma.svg";
import L_PS from "../assets/img/skills/adobeps.svg";
import L_AE from "../assets/img/skills/adobeae.svg";
import L_WP from "../assets/img/skills/wordpress.svg";
import L_SHOPIFY from "../assets/img/skills/shopify.svg";
import L_BC from "../assets/img/skills/bigcommerce.svg";


export const skills = {
  frontend: [
    {
      link: "https://en.wikipedia.org/wiki/HTML5",
      imgAltText: "HTML 5",
      imgSrc: L_HTML5,
      skillName: "HTML5",
    },
    {
      link: "https://medium.com/beginners-guide-to-mobile-web-development/whats-new-in-css-3-dcd7fa6122e1",
      imgAltText: "CSS 3",
      imgSrc: L_CSS3,
      skillName: "CSS3",
    },
    {
      link: "https://www.javascript.com/",
      imgAltText: "JavaScript",
      imgSrc: L_JAVASCRIPT,
      skillName: "JavaScript",
    },
    {
      link: "https://sass-lang.com/",
      imgAltText: "Sass",
      imgSrc: L_SASS,
      skillName: "Sass",
    },
    {
      link: "https://getbootstrap.com/",
      imgAltText: "Bootstrap",
      imgSrc: L_BOOTSTRAP,
      skillName: "Bootstrap",
    },
    {
      link: "https://material-ui.com/",
      imgAltText: "Material-UI",
      imgSrc: L_MATERIALUI,
      skillName: "Material-UI",
    },
    
    {
      link: "https://reactjs.org/",
      imgAltText: "React JS",
      imgSrc: L_REACT,
      skillName: "React JS",
    },
    {
      link: "https://reacttraining.com/react-router/",
      imgAltText: "React Router",
      imgSrc: L_REACT_ROUTER,
      skillName: "React Router",
    },
    {
      link: "https://react-bootstrap.github.io/",
      imgAltText: "React Bootstrap",
      imgSrc: L_REACT_BOOTSTRAP,
      skillName: "React Bootstrap",
    },
    {
      link: "https://redux.js.org/",
      imgAltText: "Redux",
      imgSrc: L_REDUX,
      skillName: "Redux",
    },
    {
      link: "https://nextjs.org/",
      imgAltText: "Next JS",
      imgSrc: L_NEXT,
      skillName: "Next JS",
    },
    
    
  ],

  backend: [
    {
      link: "https://nodejs.org/en/",
      imgAltText: "Node.js",
      imgSrc: L_NODE_JS,
      skillName: "Node.js",
    },
    {
      link: "https://expressjs.com/",
      imgAltText: "Express",
      imgSrc: L_EXPRESS,
      skillName: "Express",
    },
  ],
  hostingPlatforms: [
    {
      link: "https://www.netlify.com/",
      imgAltText: "Netlify",
      imgSrc: L_NETLIFY,
      skillName: "Netlify",
    },
    {
      link: "https://www.heroku.com/",
      imgAltText: "Heroku",
      imgSrc: L_HEROKU,
      skillName: "Heroku",
    },
    {
      link: "https://pages.github.com/",
      imgAltText: "GitHub Pages",
      imgSrc: L_GITHUB_PAGES,
      skillName: "GitHub Pages",
    },
  ],
  programmingLanguages: [
    {
      link: "https://www.javascript.com/",
      imgAltText: "JavaScript",
      imgSrc: L_JAVASCRIPT,
      skillName: "JavaScript",
    },
    {
      link: "https://www.typescriptlang.org/",
      imgAltText: "TypeScript",
      imgSrc: L_TYPESCRIPT,
      skillName: "TypeScript",
    },
    {
      link: "https://www.python.org/",
      imgAltText: "Python",
      imgSrc: L_PYTHON,
      skillName: "Python",
    },
  ],
  graphicDesign: [
    {
      link: "https://www.figma.com/",
      imgAltText: "Figma",
      imgSrc: L_FIGMA,
      skillName: "Figma",
    },
    {
      link: "https://www.adobe.com/products/photoshop.html",
      imgAltText: "Adobe Photoshop",
      imgSrc: L_PS,
      skillName: "Adobe Photoshop",
    },
    {
      link: "https://www.adobe.com/products/aftereffects.html",
      imgAltText: "Adobe After Effects",
      imgSrc: L_AE,
      skillName: "Adobe After Effects",
    },
  ],
  ecommerce: [
    {
      link: "https://wordpress.org/",
      imgAltText: "WordPress",
      imgSrc: L_WP,
      skillName: "WordPress",
    },
    {
      link: "https://www.shopify.com/",
      imgAltText: "Shopify",
      imgSrc: L_SHOPIFY,
      skillName: "Shopify",
    },
    {
      link: "https://www.bigcommerce.com/",
      imgAltText: "BigCommerce",
      imgSrc: L_BC,
      skillName: "BigCommerce",
    },
  ],
  databases: [
    {
      link: "https://firebase.google.com/",
      imgAltText: "Firebase",
      imgSrc: L_FIREBASE,
      skillName: "Firebase",
    },
    {
      link: "https://www.microsoft.com/en-us/sql-server/sql-server-2019",
      imgAltText: "MS-SQL",
      imgSrc: L_MSSQL,
      skillName: "MS-SQL",
    },
    {
      link: "https://www.mongodb.com/",
      imgAltText: "MongoDB",
      imgSrc: L_MONGODB,
      skillName: "MongoDB",
    },
  ],
  versionControl: [
    {
      link: "https://git-scm.com/",
      imgAltText: "GIT",
      imgSrc: L_GIT,
      skillName: "GIT",
    },
  ],
};